import { render, staticRenderFns } from "./HomeQuickMenus.vue?vue&type=template&id=05d91174"
import script from "./HomeQuickMenus.vue?vue&type=script&lang=js"
export * from "./HomeQuickMenus.vue?vue&type=script&lang=js"
import style0 from "./HomeQuickMenus.vue?vue&type=style&index=0&id=05d91174&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports